<div tabindex="-1" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered" role="">

        <div *ngIf="message" class="modal-content dirI">

            <div id="payment-receipt" class="modal-body py-0" style="margin: 0 auto;">

                <div class="d-flex flex-column justify-content-center align-items-center py-0">

                    <div [ngClass]="isSuccess ? 'success' : 'failed'" class="payment-icon mb-3">

                        <mat-icon> {{ isSuccess ? 'verified' : 'error' }} </mat-icon>

                    </div>

                    <div class="payment-title mb-3">

                        <p class="text-center"> {{ isSuccess ? ' پرداخت موفق' : 'پرداخت ناموفق' }} </p>

                        <div class="text-center">

                            <small class="text-muted">

                                {{ message | faNum }}

                            </small>

                        </div>

                    </div>

                    <div class="table-responsive" *ngIf="invoiceDetail">
                        <table class="app-table">
                            <thead>
                                <tr>
                                    <th class="text-center fw-bold">عنوان</th>
                                    <th class="text-center fw-bold">توضیحات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of invoiceDetail.Items">
                                    <td>{{item.Title}}</td>
                                    <td>{{item.Description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="payment-info my-3">

                        <div class="row gx-0 gy-0 p-3">

                            <!-- تاریخ پرداخت -->

                            <div class="col-12 mb-3">

                                <div class="w-100 h-100 d-flex justify-content-between border-bottom pb-3">

                                    <p class="mb-0 fw-bold text-muted"> تاریخ پرداخت </p>

                                    <p class="mb-0 fw-bold"> {{ (isSuccess ? obj_Payment?.strDate : '-') | faNum}} </p>

                                </div>

                            </div>

                            <!-- شماره تراکنش -->

                            <div class="col-12 mb-3">

                                <div class="w-100 h-100 d-flex justify-content-between border-bottom pb-3">

                                    <p class="mb-0 fw-bold text-muted"> شماره تراکنش </p>

                                    <p class="mb-0 fw-bold"> {{ (isSuccess ? obj_Payment?.strTransactionID : '-') | faNum}} </p>

                                </div>

                            </div>

                            <!-- شماره کارت -->

                            <div class="col-12 mb-3">

                                <div class="w-100 h-100 d-flex justify-content-between border-bottom pb-3">

                                    <p class="mb-0 fw-bold text-muted"> شماره کارت </p>

                                    <p class="mb-0 fw-bold" dir="ltr"> {{ (isSuccess ? obj_Payment?.strCartID : '-') | faNum}} </p>

                                </div>

                            </div>

                            <!-- مبلغ پرداخت شده -->

                            <div class="col-12 mb-3">

                                <div class="w-100 h-100 d-flex justify-content-between border-bottom pb-3">

                                    <p class="mb-0 fw-bold text-muted"> مبلغ پرداخت شده </p>

                                    <p class="mb-0 fw-bold"> {{ (isSuccess ? obj_Payment?.iAmount : '0') | number | faNum }} ریال </p>

                                </div>

                            </div>

                            <!-- وضعیت -->

                            <div class="col-12 mb-3">

                                <div class="w-100 h-100 d-flex justify-content-between border-bottom pb-3">

                                    <p class="mb-0 fw-bold text-muted"> وضعیت </p>

                                    <p class="mb-0 fw-bold">

                                        <small [ngClass]="isSuccess ? 'bg-success' : 'bg-danger'" class="badge rounded-pill">

                                            {{ isSuccess ? 'پرداخت شده' : 'پرداخت ناموفق' }}

                                        </small>

                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div class="payment-buttons w-100">

                        <div class="row gx-3 gy-0 ">

                            <div [ngClass]="isSuccess ? 'col-6' : 'd-none'">

                                <button class="w-100 btn btn-success" (click)="saveShot()">

                                    چاپ

                                </button>

                            </div>

                            <div [ngClass]="isSuccess ? 'col-6' : 'col-12'">

                                <button class="w-100 btn btn-outline-secondary" data-bs-dismiss="modal" routerLink="/profile">

                                    &nbsp; بازگشت به سامانه &nbsp;

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>